import { render } from "./VendorGroupList.vue?vue&type=template&id=7fe9668e"
import script from "./VendorGroupList.vue?vue&type=script&lang=js"
export * from "./VendorGroupList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__